<template>
  <div class="search">
    <el-icon v-if="visible" class="icon" @click="visibleHandler(!visible)">
      <Minus />
    </el-icon>
    <el-icon v-else class="icon" @click="visibleHandler(!visible)">
      <Plus />
    </el-icon>
    <div class="search-content" v-show="visible">
      <el-icon class="icon-arrow"><CaretTop /></el-icon>
      <div class="layout">
        <div class="layout-left">
<!--          <div class="desc">开发商自选</div>-->
          <span class="select-button" @click="confirmSearch">确定查询</span>
          <div class="desc">已选开发商{{selected.length}}</div>
          <ul class="selected-list">
            <li v-for="v in selected">{{v.projectDeveloper}}
              <el-icon @click="dataCancelHandler(v.id)">
                <Close />
              </el-icon>
            </li>
          </ul>
        </div>

        <div class="layout-right">
            <el-input placeholder="请输入开发商" :suffix-icon="Search" v-model="keyword"/>
            <div class="dev-list">
              <p v-for="v in data" :key="v.id">
                <el-checkbox
                    :disabled="selected.length === 8"
                    :label="v.projectDeveloper"
                    v-model="v.checked"
                    @change="dataHandler($event, v.id)"
                />
              </p>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {Plus, Minus, CaretTop, Search, Close} from "@element-plus/icons-vue";
import {ref, watch, watchEffect} from "vue";
import request from "@/service/request";
import {GetDeveloperNameList} from "@/service/api";
const props = defineProps(['code'])
const emits = defineEmits([''])

// 控制菜单是否显示
const visible = ref(false);
// 控制内容是否被选中
const selected = ref([]);
const data = ref([]);
// 关键字搜索
const keyword = ref('')

const visibleHandler = (v) => {
  v ? openPanel(v) : closePanel(v);
}

const dataSelectHandler = (id) => {
  if(selected.value.length >= 8) return;
  let i = data.value.findIndex(e => e.id === id);
  // 标注数据被选择了
  data.value[i].checked = true;
  selected.value = data.value.filter(v => v.checked);
}
const dataCancelHandler = (id) => {
  let i = data.value.findIndex(e => e.id === id)
  // 标注数据被
  data.value[i].checked = false;
  selected.value = data.value.filter(v => v.checked);
}
const dataHandler = (e, id) => {
  e ? dataSelectHandler(id)
    : dataCancelHandler(id)
}

function confirmSearch(){
  let result = selected.value.map(e => e.projectDeveloper)
  if(result && result.length > 0){
    emits('onSearch', result.join(','))
    visible.value = false;
  }
}

async function openPanel(_v){
  let {data: v} = await request({
    method: 'get',
    url: GetDeveloperNameList,
    data: {
      cityCode: props.code,
    }
  })
  data.value = v.map(name => ({id: name, projectDeveloper: name, checked: false}) );
  visible.value = _v;
  keywordHandler();
}

function closePanel(v){
  watchEffect(() => {
    data.value = [];
    visible.value = v;
  })
}

function keywordHandler(){
  let v = data.value;
  let timer;
  watch(keyword, (v1) => {
    if(v1){
      clearTimeout(timer)
      timer = setTimeout(() => {
        data.value = v.filter(e => e.projectDeveloper && e.projectDeveloper.indexOf(keyword.value) >= 0)
      }, 300)
    }else{
      data.value = v;
    }
  });
}
</script>

<style scoped>

.select-button{
    float: right;
    margin-top: 6px;
}

.desc{
  height: 30px;
  line-height: 30px;
  color: #0064f2;
}

.selected-list{
  border-top: 2px solid #dedede;
  max-height: 160px;
  overflow-y: auto;
}

.dev-list{
  margin-top: 3px;
  height: 180px;
  padding: 3px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
}

.layout{
  display: flex;
  column-gap: 20px;
}

.layout-left, .layout-right{
  box-sizing: border-box;
  flex: 1;
  width: 0;
}

.layout-left{

}

.layout-right{
  border-radius: 4px;
}

.search{
  position: absolute;
  z-index: 1;
  top: 43px;
  left: 165px;
  width: 20px;
  height: 20px;
  margin-left: 8px;
  cursor: pointer;
  user-select: none;
}

.search-content{
  position: absolute;
  top: 34px;
  left: -60px;
  width: 460px;
  z-index: 9;
  background: #fff url("../../../../assets/images/h_bg1.png") repeat-x;
  background-size: 100% 100%;
  border-radius: 8px;
  padding: 20px;
}

.icon{
  font-size: 14px;
  font-weight: bold;
}

.icon-arrow{
  position: absolute;
  font-size: 20px;
  top: -16px;
  color: #0064f2;
}
</style>